import { onChangeLevel } from './onChangeLevel';
import { sendToBus } from '../../../../../components/Bus';
import { getCurrentLevelName } from '../hooks/useCurrentLevel';

import { useTrackStore } from '~/scenes/Build/scenes/FlowBuilder/stores';

export const goToComponent = (
  nodeId: string,
  offsetX?: number,
  offsetY?: number
) => {
  sendToBus({ event: { type: 'UNSELECT_ALL' }, to: 'flowCanvas' });

  const panToComponent = () => {
    setTimeout(() => {
      sendToBus({
        event: { type: 'PAN_TO_COMPONENT', nodeId, offsetX, offsetY },
        to: 'flowCanvas'
      });
    }, 175);
  };

  const currentLevelName = getCurrentLevelName();

  if (nodeId === 'trigger' || nodeId === 'starter-node') {
    if (currentLevelName === 'start') {
      return panToComponent();
    }
    onChangeLevel('root', 'start');
    return panToComponent();
  }

  if (nodeId === 'start-track') {
    return panToComponent();
  }

  const levelToGoName = useTrackStore
    .getState()
    .getLevelNameForComponent(nodeId);

  if (levelToGoName === currentLevelName) {
    return panToComponent();
  }

  if (levelToGoName === 'start') {
    onChangeLevel('root', 'start');
    return panToComponent();
  }

  const levelType = levelToGoName.endsWith('-onProcessTrack')
    ? 'onProcess'
    : 'onException';
  const parentComponentId = levelToGoName.replace(
    /-on(Process|Exception)Track$/,
    ''
  );

  onChangeLevel(parentComponentId, levelType);
  return panToComponent();
};
